<template>
  <v-row justify-center>
    <v-dialog v-model="localDialog" :width="$vuetify.breakpoint.smAndDown ? '95vw' : '500px'">
      <v-card>
        <!-- <v-card-title>
          <v-btn class="float-right" icon @click="localDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->
        <v-form ref="form">
          <v-col
            cols="12"
            md="12"
            xs="12"
            sm="12"
            :class="[$vuetify.breakpoint.smAndDown ? 'mt-0 pb-4 px-2' : 'mt-n12 pb-16']"
            justify-center
          >
            <v-col cols="12" md="12" xs="12" sm="12" :class="$vuetify.breakpoint.smAndDown ? 'pl-2 pr-2' : 'pl-16'">
              <div
                :style="$vuetify.breakpoint.smAndDown
                  ? 'font-family:Ebrima;font-weight:700;font-size:28px;line-height:34px;color:#0b3a8f;margin-top:16px;'
                  : 'font-family:Ebrima;font-weight:700;font-size:38px;line-height:48px;color:#0b3a8f;margin-top:48px;'
                "
              >
                {{$t("loginpage.login") }}
              </div>
              <span
                :style="$vuetify.breakpoint.smAndDown
                  ? 'font-family:Ebrima;font-weight:400;font-size:14px;color:#a1a1a1;line-height:18px;'
                  : 'font-family:Ebrima;font-weight:400;font-size:18px;color:#a1a1a1;line-height:22px;'
                "
              >
                ONE Conference Anywhere Anytime
              </span>
            </v-col>
            <v-col cols="12" md="12" xs="12" sm="12" :class="$vuetify.breakpoint.smAndDown ? 'px-2 pb-0' : 'px-16 pb-0'">
              <!-- :placeholder= "$t('loginpage.username')" -->
              <v-text-field
                outlined
                dense
                :oninput="onlyuser"
                @keypress="userpassword"
                v-model="username"
                rounded
                :prefix="$t('loginpage.username')"
                append-icon="mdi-account"
              ></v-text-field>
              <!-- :placeholder= "$t('loginpage.password')" -->
              <v-text-field
                outlined
                dense
                v-model="password"
                :oninput="onlypass"
                rounded
                v-on:keyup="enterToLogInOneId"
                :prefix="$t('loginpage.password')"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-col>
            <v-row cols="12" md="12" xs="12" sm="12" :class="$vuetify.breakpoint.smAndDown ? 'pl-2 ml-0 pb-4' : 'mb-6 pb-2 pl-16 ml-1'">
              <span
                class="pointer"
                @click="forgotPassword"
                style="
                  font-family: IrisUPC;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: #a1a1a1;
                  line-height: 22px;
                  text-decoration: underline;
                  cursor: pointer;
                  display: inline-block;
                "
              >
                {{$t("loginpage.forgotpassword") }}?
              </span>
            </v-row>
            <v-row no-gutters align="start" :class="$vuetify.breakpoint.smAndDown ? 'mt-0 pl-2 ml-0' : 'mt-n4 pl-16 ml-1'">
              <v-col cols="auto" class="d-flex justify-center" style="max-width:40px;">
                <v-checkbox
                  color="#00BFA5"
                  value="success"
                  hide-details
                  v-model="checkbox"
                  class="ma-0 pa-0"
                  style="margin-top:0;"
                />
              </v-col>
              <v-col class="d-flex flex-column justify-center" style="white-space:normal;">
                <div style="line-height:1.2;">
                  <span>{{$t("loginpage.Accept") }}</span>
                  <span class="pointer" @click="PrivacyNotice()" style="color:#2083e4; cursor: pointer;">
                    {{$t("loginpage.oneid") }}
                  </span>
                  <span>{{$t("loginpage.and") }}</span>
                </div>
                <div style="line-height:1.2;">
                  <span class="pointer" @click="ProtectionPolicy()" style="color:#2083e4;cursor: pointer;">
                    {{$t("loginpage.Privacy") }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-col cols="12" md="12" xs="12" sm="12" :class="$vuetify.breakpoint.smAndDown ? 'px-2 pt-6' : 'px-16 pt-8'">
              <v-btn
                depressed
                block
                rounded
                color="#3D85C6"
                style="color: white"
                @click="loginoneid()"
                :disabled="Disabled"
                :loading="loadingApiLogin"
              >
              {{$t("loginpage.login") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="12" xs="12" sm="12" :class="$vuetify.breakpoint.smAndDown ? 'px-2' : 'px-16'">
              <v-btn
                depressed
                block
                rounded
                color="error"
                @click="localDialog = false"
              >
              {{$t("loginpage.cancel") }}
              </v-btn>
            </v-col>
            <!-- <v-col cols="12" md="12" xs="12" sm="12" class="px-14 mr-0"> -->
              <!-- <v-row class="pl-12">
                <v-col cols="3" lg="3" class="float-rigth ma-2 px-0">
                  <b><v-divider class="vDivider" /></b>
                </v-col>
                <v-col
                  cols="2"
                  lg="2"
                  class=" ma-4 detailVider px-0"
                  style="color: #a1a1a1"
                >
                  <b>หรือ Login with</b>
                </v-col>
                <v-col cols="3" lg="3" class="float-rigth ma-2 px-0">
                  <b><v-divider class="vDivider" /></b>
                </v-col>
              </v-row> -->
            <!-- </v-col> -->
            <!-- <v-col cols="12" md="10" xs="12" sm="12" class="ml-9 pl-16 py-0">
              <v-avatar color="#0B3A8F" style="color: white">
                <v-icon dark> mdi-email-outline </v-icon>
              </v-avatar>
              <span class="pl-3 pt-3">ONE COLLABORATION MAIL</span>
            </v-col> -->
            <v-col cols="12" md="12" xs="12" sm="12" :class="$vuetify.breakpoint.smAndDown ? 'ml-0 px-2' : 'ml-3 px-16'">
              <span>{{$t("loginpage.notuser") }} ?</span>
              <v-btn
                @click="openModelSignup"
                text
                color="#00DAAD"
                class="p-0 m-0 mt-n1"
              >
              {{$t("loginpage.Register") }}
              </v-btn>
            </v-col>
          </v-col>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CryptoJS from "crypto-js";
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      onlyuser: "this.value = this.value.replace(/[^0-9a-zA-Z!().,`|_;:@#$%&*~+-/?]|/g, '')",
      onlypass: "this.value = this.value.replace(/[^0-9a-zA-Z!(){}''.|=`<>,^_;:@#$%&*~+-/?]|/g, '')",
      username: '',
      jwt: require('jsonwebtoken'),
      password: '',
      show1: false,
      Disabled: true,
      loadingApiLogin: false,
      checkbox: false,
      usertoken: ''
    }
  },
  watch: {
    checkbox(value) {
      if (value) {
        this.conditionDialbleBtnLogin()
      } else {
        this.Disabled = true
      }
    }
  },
  created() {
    this.uuid = this.$route.query.uuid
    // console.log('uuid', this.uuid)
    if (localStorage.getItem('user-token') === null) {
      console.log('NO user-token')
    } else {
      // this.checkrole()
      // this.goPage('/activate')
      this.goPage("/manage");
    }
    this.$multiwatch(['username', 'password'], function () {
      const valid = this.$refs.form.validate()
      if (this.checkbox === true) {
        this.Disabled = !valid
      }
    })
  },
  computed: {
    ...mapState('dialog', ['dialogLogin']),
    localDialog: {
      get() {
        return this.dialogLogin
      },
      set(value) {
        this.setDialogLogin(value)
      }
    }
  },
  methods: {
    ...mapActions('dialog', ['setDialogLogin']),
    closeDialog() {
      this.setDialogLogin(false)
    },
    openModelSignup() {
      window.open('https://one.th/register', '_blank')
    },
    userpassword(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode
      if (key >= 33 && key <= 64) {
        return true
      } // number
      if (key >= 65 && key <= 90) {
        return true
      } // A-Z
      if (key >= 97 && key <= 122) {
        return true
      } // a-z
      return e.preventDefault()
    },
    PrivacyNotice() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 0,
        "_blank"
      );
    },
    ProtectionPolicy() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 1,
        "_blank"
      );
    },
    encodeJS(data) {
      // console.log(data)
    try {
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        process.env.VUE_APP_SECRET_KEY
      ).toString();
      this.usertoken = ciphertext
      return ciphertext;
    } catch (error) {
      console.log(error);
      return error;
    }
    },
    loginoneid() {
      if (this.username === '' && this.password === '') {
        // this.$swal('Please, enter "Username" and "Password"', '', 'warning')
        this.$swal(this.$t('loginpage.Pleaseenter') + this.$t('loginpage.usernameorpass') ,'', 'warning')
      } else if (this.username !== '' && this.password === '') {
        // this.$swal('Please, enter "Password"', '', 'warning')
        this.$swal(this.$t('loginpage.Pleaseenter') + this.$t('loginpage.password'),'', 'warning')
      } else if (this.username === '' && this.password !== '') {
        this.$swal(this.$t('loginpage.Pleaseenter') + this.$t('loginpage.username'),'', 'warning')
      } else {
        this.loadingApiLogin = true
        this.Disabled = true
        this.encodeJS(JSON.stringify({ username: this.username, password: this.password}))
        this.axios
        .post(process.env.VUE_APP_API + '/api/lv1/auth/login', {
          token : this.usertoken
        })
        .then((res) => {
          console.log(res)
          if (res.data.code === 200) {
            console.log('200', res.data)
            if (res.data.result === 'Success') {
              this.loadingApiLogin = false
              this.Disabled = false
              localStorage.setItem('user-token', res.data.data.token)
              localStorage.setItem("oneid-token", res.data.data.oneid);
              // localStorage.setItem('access-token', res.data.data.oneid.access_token)
              // localStorage.setItem( "refresh_token",  res.data.data.oneid.refresh_token );
              this.decodejwttoken(res.data.data.token)
              // this.checkrole()
              // console.log('Success', res.data)
              // if (this.$route.query.uuid === undefined) {
              //       this.goPage("/manage");
              //     } else {
              //       this.goPage('/join/?uuid=' + this.uuid )
              //     }
              // this.$swal(res.data.message, '', 'success')
              this.$swal(this.$t("loginpage.login"), this.$t("loginpage.Successfully"), 'success')
            } else {
              this.loadingApiLogin = false
              this.Disabled = false
              // this.$swal(res.data.message, 'aaa', 'warning')
              this.$swal(this.$t("loginpage.idpassincorrect"),'', 'warning')
              // console.log('warning', res.data)
            }
          } else {
            // console.log('else', res.data)
            this.$swal(this.$t("loginpage.idpassincorrect"), "", "warning");
            // this.$swal(res.data.message, 'yy', 'warning')
            this.loadingApiLogin = false
            this.Disabled = false
          }
        })
        .catch((e) => {
          this.$swal("Cannot read properties of undefined", "", "warning");
          console.log('400', e)
          this.loadingApiLogin = false
          this.Disabled = false
        })
      }
      //   console.log('env', process.env.VUE_APP_API)
      //   console.log('username', this.username)
      //   console.log('password', this.password)
    },
    decodejwttoken(data) {
      var token = data
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      // var userData = data
      // console.log('this.userData', data.user._id)
      this.createthem(data.user._id)
    },
    createthem(userid) {
      // this.axios
      //     .post(process.env.VUE_APP_API + "/api/v1/theme/create/", {
      //       user_id: userid
      // }).then(res => {
      //   if( res.data.result === 'Created' || res.data.result === 'Success'){
          if(this.uuid !== '' || this.uuid !== null) {
                this.goPage('/join/?uuid=' + this.uuid )
              } else {
                // this.goPage('/activate')
              this.goPage("/manage");
              }
      //   }
      // }).catch(err => {
      //   console.log('createidprofile', err.message)
      // })
    },
    goPage(link) {
      this.$router.push(link).catch(() => {})
    },
    conditionDialbleBtnLogin() {
      const valid = this.$refs.form.validate()
      if (valid === true) {
        this.Disabled = false
      } else {
        this.Disabled = true
      }
    },
    forgotPassword() {
      window.open(
        process.env.VUE_APP_ONEID + "/type_forgot_password",
        "_blank"
      );
    },
    enterToLogInOneId: function (e) {
      if (e.keyCode === 13) {
        if (this.Disabled === true) {
          this.$swal(
            "Please" , this.$t("loginpage.oneid"),
            '',
            'warning'
          )
        } else {
          this.loginoneid()
        }
      }
    }
  }
}
</script>
<style scoped>
.background {
  background-image: url("~@/assets/fram_bg.jpg");
  background-position: right;
  transform: translate(1px, 0px);
  height: 100%;
  width: 100%;
  left: 10%;
  background-repeat: no-repeat;
  background-size: cover;
}
.vDivider {
  width: 100%;
  background: #a1a1a1;
  border-bottom: 1px solid #a1a1a1;
}
.detailVider {
  font-size: 9.3px;
}
.bgTransparent {
  background-color: transparent !important;
}
</style>
